// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__frX8t","box":"WorkspacesBox_box__3qb7m","node":"WorkspacesBox_node__3Ud1k"};